import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=6754a61c&"
import script from "./Brokers.vue?vue&type=script&lang=js&"
export * from "./Brokers.vue?vue&type=script&lang=js&"
import style0 from "./Brokers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports